import React from 'react';

export type BassitWordmarkVariant = 'en' | 'ar';

export type BassitWordmarkProps = {
  variant?: BassitWordmarkVariant;
  size?: number;
  color?: string;
  className?: string;
};

/**
 * Wordmark. Two production variants:
 *   en — "BassitAI" set in Newsreader 500 with serif italic AI accent
 *   ar — "باسط" set in Noto Naskh Arabic
 *
 * The AI is rendered as a serif italic in the brand color so the mark reads
 * as both a name and a typographic statement.
 */
export function BassitWordmark({
  variant = 'en',
  size = 22,
  color = 'currentColor',
  className = '',
}: BassitWordmarkProps) {
  if (variant === 'ar') {
    return (
      <span
        className={`inline-flex items-baseline leading-none ${className}`}
        style={{
          fontFamily: 'var(--font-arabic)',
          fontWeight: 500,
          fontSize: size,
          color,
          direction: 'rtl',
        }}
        aria-label="BassitAI"
      >
        باسط
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-baseline leading-none whitespace-nowrap ${className}`}
      style={{
        fontFamily: 'var(--font-display)',
        fontWeight: 500,
        fontSize: size,
        letterSpacing: '-0.01em',
        color,
      }}
      aria-label="BassitAI"
    >
      Bassit
      <span
        style={{
          fontFamily: 'var(--font-display)',
          fontStyle: 'italic',
          fontWeight: 500,
          letterSpacing: '-0.025em',
          color: 'var(--brand)',
          marginLeft: 1,
        }}
      >
        AI
      </span>
    </span>
  );
}

export default BassitWordmark;
